import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Navbar from "./Components/Navbar";
import Home from "./Pages/Home";
import PdfToData from "./Pages/PdfToData";
import Footer from "./Components/Footer";

export default function App() {
	return (
		<Router>
			<div className="flex flex-col h-full">
				<Navbar />
				<Routes>
					<Route path="/" element={<Home title="Home" />} />
					<Route path="/pdf2data" element={<PdfToData title="Pdf To CSV" />} />
				</Routes>
				<Footer />
			</div>
		</Router>
	);
}
